import fetchWithAuth from "./fetchWithAuth";
import handleResponse from "./handleResponse";
const API_URL = process.env.REACT_APP_API_URL;

export const login = (companyCode, loginId, password) =>
  fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ companyCode, loginId, password }),
  }).then(handleResponse);

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return null;
  const res = await fetch(`${API_URL}/auth/refresh`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refreshToken }),
  });
  if (!res.ok) return null;
  const data = await res.json();
  return data.accessToken;
};

// 로그인된 본인 계정의 비밀번호 변경 (admin/company 공통)
export const changePassword = (currentPassword, newPassword) =>
  fetchWithAuth(`${API_URL}/auth/password`, {
    method: "PATCH",
    body: JSON.stringify({ currentPassword, newPassword }),
  }).then(handleResponse);